import React from "react"
import PropTypes from "prop-types"
import "./PageBanner.scss"

const PageBanner = (props) => {
  return (
    <div className={`PageBanner ${props.className ? props.className : ""}`}>
      {props.children}
    </div>
  )
}

PageBanner.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  className: PropTypes.string,
}

export default PageBanner
